<template>
    <section class="section row">
        <slot>
        </slot>
    </section>
</template>

<script>
export default {
  name: 'row'
}
</script>

<style lang="scss">
    .section {
        padding: rem(40px) rem(135px);

        &.row {
            margin: 0;
        }
    }
</style>
